import React from 'react'
import { CreateFormTrainContainer } from '../../containers/Officer/CreateFormTrainContainer'
export const CreateFormTrainPage = () => {
  return (
    <CreateFormTrainContainer />
  )
}
